import * as React from "react";
import { Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { MetricsService, ReportFileInfo } from "gen/clients";

interface Props {
  reportId: string;
  csvFile: ReportFileInfo;
}

const ExportFileTypesByClientReportButton: React.FC<Props> = ({ reportId, csvFile }) => {
  const [isDownloading, setIsDownloading] = React.useState(false);

  const handleExport = React.useCallback(async () => {
    try {
      setIsDownloading(true);

      const response = await MetricsService.downloadReportJobFile({
        reportId,
        s3Key: encodeURIComponent(csvFile.s3Key)
      });

      const link = document.createElement("a");
      link.href = response.downloadUrl;
      link.download = `file-types-by-client-report-${reportId}.csv`;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Failed to download report file:", error);
    } finally {
      setIsDownloading(false);
    }
  }, [reportId, csvFile.s3Key]);

  return (
    <Button
      variant="outlined"
      startIcon={<DownloadIcon />}
      onClick={handleExport}
      disabled={isDownloading}
      sx={{ whiteSpace: "nowrap" }}
    >
      {isDownloading ? "Downloading..." : "Export to CSV"}
    </Button>
  );
};

export { ExportFileTypesByClientReportButton };
